
import { defineComponent } from 'vue';
import { useCookies } from 'vue3-cookies';

import { COOKIES_USAGE_CONFIRMATION, SESSION_COOKIE, COMPANY_LOGIN_COOKIE } from '@/constants';

export default defineComponent({
  name: 'CookieNotice',

  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },

  data(): {
    isShow: boolean;
  } {
    return {
      isShow: true,
    };
  },

  computed: {
    isShowCookieNotice(): boolean {
      return this.isShow && !this.cookies.isKey(COOKIES_USAGE_CONFIRMATION);
    },
  },

  mounted() {
    if (!this.cookies.isKey(COOKIES_USAGE_CONFIRMATION)) {
      const cookiesForRemove = this.cookies
        .keys()
        .filter((cookie) => ![SESSION_COOKIE, COMPANY_LOGIN_COOKIE].includes(cookie));

      cookiesForRemove.forEach((cookie) => {
        const { location } = window;
        const hostParts = location.hostname.split('.');

        while (hostParts.length > 0) {
          const pathParts = location.pathname.split('/');
          while (pathParts.length > 0) {
            this.cookies.remove(cookie, pathParts.join('/'), hostParts.join('.'));
            pathParts.pop();
          }
          hostParts.shift();
        }
      });
    }
  },

  methods: {
    setCookie() {
      this.cookies.set(COOKIES_USAGE_CONFIRMATION, 'true', '1Y', '/', '', false, '');
      this.isShow = false;
    },
  },
});
